export class ConstantePage {

  // Marqueur Web-Analytic - GLOBAL
  static STATS_LEVEL2 = '12';
  static STATS_CHAPTER1 = 'simulation';
  static STATS_CHAPTER2 = 'aide_au_logement';

  // Marqueur Web-Analytic - PAGE 
  // Page Accès 
  static STATS_PAGE_ACCUEIL_NON_AUTHENTIFIE = 'simu_al_accueil_non_authentifie';
  static STATS_PAGE_ACCUEIL_ALLOCATAIRE = 'simu_al_accueil_authentifie';  
  static STATS_CHAPTER3_PAGE_ACCUEIL = 'accueil';  
  // Page Déclaration
  static STATS_PAGE_DECLARATION = 'simu_al_declaration';
  static STATS_PAGE_DECLARATION_ENFANT = 'simu_al_declaration_enfant';
  static STATS_CHAPTER3_PAGE_DECLARATION = 'declaration';
  // Page Resultat
  static STATS_PAGE_RESULTAT_DROIT = 'simu_al_resultat_droit';
  static STATS_PAGE_RESULTAT_NON_DROIT = 'simu_al_resultat_non_droit';
  static STATS_CHAPTER3_PAGE_RESULTAT = 'fin';
  // Page Incident
  static STATS_PAGE_INCIDENT = 'erreur';
  static STATS_CHAPTER3_PAGE_INCIDENT = 'incident';
  
  
  // Marqueur Web-Analytic - CLIC
  static STATS_CLIC_NATURE_LOGEMENT = 'nature_logement';
  static STATS_CLIC_RESSOURCES_USAGER = 'ressources_nettes_usager';
  static STATS_CLIC_RESSOURCES_CONJOINT = 'ressources_nettes_conjoint';
  static STATS_CLIC_RESSOURCES_ENFANT = 'ressources_nettes_enfant';
  static STATS_CLIC_ABANDON = 'abandon';
  static STATS_CHAPTER1_CLIC_INFOBULLE = 'infobulle';

}
